/*
 * File: EntryLayout.tsx
 * Project: a-a
 * File Created: Friday, 11th October 2024 2:00:44 am
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 23rd July 2025 9:47:23 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */

import React, { ReactNode } from 'react';
import styles from './EntryLayout.module.css';
import CustomButton from '../CustomButton/CustomButton';
import zeplinColor from '../../../theme/Color';
import CustomSeperator from '../CustomSeperator/CustomSeperator';
import { Link } from 'react-router-dom';
import RoutePaths from '../../../routes/RoutePaths';
import { Box, Divider, Typography } from '@mui/material';
import CustomAlert from '../CustomAlert/CustomAlert';
import CustomLoader from '../CustomLoader/CustomLoader';
import packageJson from '../../../../package.json';

type EntryLayout = {
  header: string;
  subheader: string;
  input: ReactNode;
  alternative?: ReactNode;
  footerText: string;
  footerButtonText: string;
  path?: RoutePaths;
  icon?: ReactNode;
  clickAction: any;
  alert?: string;
  handleClose?: () => void;
  alertIcon?: ReactNode;
  error?: boolean;
  footer?: boolean;
  open?: boolean;
  handleCloseModal?: () => void;
};

const EntryLayoutScreen = ({
  header,
  subheader,
  input,
  alternative,
  footerButtonText,
  footerText,
  path,
  icon,
  clickAction,
  alert,
  handleClose,
  alertIcon,
  error,
  footer = true,
  open = false,
  handleCloseModal,
}: EntryLayout) => {
  // const [email,setEmail]=useState('')

  const version = packageJson.version;
  const alertMessage = (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12 }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          // backgroundColor: !error ? zeplinColor.Success : '',
          borderRadius: '60px',
          padding: '3px',
        }}
      >
        {alertIcon ? alertIcon : ''}
      </div>
      <Typography variant='body2' style={{ color: zeplinColor.Neutral1 }}>
        {alert}
      </Typography>
    </div>
  );

  return (
    <div className={styles['grid-container']}>
      <div className={styles.entrycontainer}>
        <div className={styles.entryformcontainer}>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <img className={styles['entry-logo']} src={'/assets/new-logo.png'} alt='logo' />
          </div>
          <div className={styles['form-logo-input']}>
            <div className={styles['form-inputs']}>
              <div className={styles['entry-header-container']}>
                {icon && icon}
                <h1 className={styles['entry-header']}>{header}</h1>
                <p className={styles['entry-subheader']}>{subheader}</p>
              </div>

              {input}
              {alternative && (
                <div style={{ width: '50%', margin: '0px auto 0px' }}>
                  <CustomSeperator
                    text='OR'
                    style={{
                      borderWidth: 1,
                      borderColor: zeplinColor.Neutral9,
                      width: '100%',
                      color: zeplinColor.Neutral9,
                    }}
                  />
                </div>
              )}
              {alternative}
            </div>
            {path && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <p style={{ color: zeplinColor.Neutral9, margin: 0 }}>{footerText}</p>
                <Link to={path}>
                  <CustomButton
                    disabled={false}
                    variant='text'
                    text={footerButtonText}
                    textStyle={{ color: zeplinColor.Brand1 }}
                    onClick={clickAction}
                  />
                </Link>
              </div>
            )}
          </div>
        </div>
        <CustomAlert
          open={alert ? true : false}
          handleClose={handleClose ? handleClose : () => {}}
          message={alertMessage}
          error={error}
        />
      </div>

      {footer && (
        <div className={styles.footerContainer}>
          <div className={styles.footer}>
            <Typography variant='body3' color={zeplinColor.Neutral9}>
              ©2025 A&A Management {process.env.REACT_APP_VERSION}
            </Typography>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              {/* <Link to={RoutePaths.Terms}> */}
              <Typography variant='body3' color={zeplinColor.BasicBlack}>
                Terms{' '}
              </Typography>
              {/* </Link> */}
              {/* <Divider orientation='vertical' /> */}
              <Box
                sx={{
                  height: '16px',
                  width: '1px',
                  backgroundColor: zeplinColor.Neutral5,
                  display: 'inline-block',
                  marginX: '4px', // Add some margin on both sides
                }}
              />
              {/* <Link to={RoutePaths.Privacy}> */}
              <Typography variant='body3' color={zeplinColor.BasicBlack}>
                Privacy
              </Typography>
              {/* </Link> */}
            </div>
          </div>
        </div>
      )}
      <CustomLoader open={open} handleCloseModal={handleCloseModal} />
    </div>
  );
};

export default EntryLayoutScreen;
